import React, { useEffect, useContext } from "react";
import { Dropdown, Menu } from "antd";
import IconFont from "@/components/icon";
import { connect } from "dva";
import styles from "./index.module.less";
import { dealImagesData } from "@/components/chat/utils/image";
import { FocusSDK } from "@/utils";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
// import { CustomMenu } from "@jd/focus-desktop-comps";
import CustomMenu from "@/baseComponents/CustomMenu";

function ScreenCapture({
  captureType,
  setCaptureType,
  file
}: {
  captureType: string;
  setCaptureType: Function;
  file: any;
}) {
  const { localConfigData } = useContext<GlobalContextConfig>(GlobalContext);

  useEffect(() => {
    // const calendarImService: CalendarImServiceType = CalendarImService.getInstance();
    setCaptureType({ captureType: localConfigData.captureType || "1" });
  }, [setCaptureType, localConfigData]);

  useEffect(() => {
    if (file) {
      dealImagesData(file).then((res) => {
        console.log(res);
      });
    }
  }, [file]);

  const handleMenuClick = ({ key }: any) => {
    FocusSDK.setConfigData("captureType", key);
    setCaptureType({ captureType: key });
  };

  function handleCaptureClick() {
    setTimeout(() => {
      // 截屏api调用
      FocusSDK.captureScreen((data) => {
        console.log(data);
      });
    }, 300);
  }

  const menu = (
    <Menu className="input-dropdown-menu" selectable={true} defaultSelectedKeys={[captureType]} onClick={handleMenuClick}>
      <Menu.Item key="1" className="input-dropdown-menu-item">
        <span className="text">隐藏窗口截图</span>
      </Menu.Item>
      <Menu.Item key="2" className="input-dropdown-menu-item">
        <span className="text">不隐藏当前窗口</span>
      </Menu.Item>
    </Menu>
  );

  const renderScreenCaptureDropdownContextMenu = () => {
    const menuItems = [
      {
        key: '1',
        label: "隐藏窗口截图",
        clstag: "pageclick|keycount|Xtbg_Msg_Home|InfoMoreDelete",
        active: captureType === "1"
      },
      {
        key: '2',
        label: "不隐藏当前窗口",
        clstag: "pageclick|keycount|Xtbg_Msg_Home|InfoMoreTop_True",
        active: captureType === "2"
      }
    ]
    return (
      <CustomMenu styleObj={{minWidth: "124px"}} selectable={true} defaultSelectedKeys={[captureType]} onClick={handleMenuClick} items={menuItems} />
    )
  }

  return (
    <Dropdown overlay={renderScreenCaptureDropdownContextMenu} placement="bottomCenter" trigger={["hover"]}>
      <div className={styles["capture-icon-group"]}>
        <IconFont
        className={styles["input-icon"]}
          // className="at input-button capture-icon input-button-v2"
          type="iconjietu"
          onClick={handleCaptureClick}
        // clstag={
        //   quillModal
        //     ? "pageclick|keycount|Xtbg_Msg_Info_MsgDialog|RichTextMessage_SCreenShot"
        //     : "pageclick|keycount|focus_chat_01_1602584371145|42"
        // }
        />
         <IconFont type="iconfasongjiantou" className={styles["dropdown-icon"]} />
      </div>
    </Dropdown>
  );
}
function mapStateToProps({ chat }: any) {
  return {
    captureType: chat.captureType
  };
}
function mapDispatchToProps(dispatch: any) {
  return {
    async setCaptureType(data: { captureType: string }) {
      await dispatch({ type: "chat/setCaptureType", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ScreenCapture);
